export function buildReferralShareLinks(shareUrl: string) {
  const encoded = encodeURIComponent(shareUrl);

  return {
    mail: `mailto:?subject=${encodeURIComponent('Book with BCC')}&body=${encoded}`,
    sms: `sms:?&body=${encoded}`,
    whatsApp: `https://wa.me/?text=${encoded}`,
    messenger: `https://www.facebook.com/dialog/send?link=${encoded}&redirect_uri=${encoded}`,
  };
}
